/* Dusty's Trail Dust — global.js
   Small, dependency-free behaviors. Everything is delegated and idempotent. */
(function () {
  'use strict';

  /* ---- Mobile nav toggle (header) ---- */
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-nav-toggle]');
    if (toggle) {
      var panel = document.getElementById(toggle.getAttribute('aria-controls'));
      if (!panel) return;
      var open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!open));
      panel.toggleAttribute('hidden', open);
      document.documentElement.classList.toggle('nav-open', !open);
      return;
    }

    /* ---- Close open nav dropdowns when clicking outside ---- */
    document.querySelectorAll('details[data-dropdown][open]').forEach(function (d) {
      if (!d.contains(e.target)) d.removeAttribute('open');
    });

    /* ---- Quantity steppers: <button data-qty-change="1|-1"> next to input[data-qty-input] ---- */
    var stepper = e.target.closest('[data-qty-change]');
    if (stepper) {
      var wrap = stepper.closest('[data-qty]') || stepper.parentElement;
      var input = wrap && wrap.querySelector('[data-qty-input]');
      if (input) {
        var step = parseInt(stepper.getAttribute('data-qty-change'), 10) || 1;
        var min = parseInt(input.min || '1', 10);
        var next = (parseInt(input.value, 10) || min) + step;
        if (next >= min) {
          input.value = next;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    }

    /* ---- Product gallery: thumbnails swap the featured image ---- */
    var thumb = e.target.closest('[data-gallery-thumb]');
    if (thumb) {
      var gallery = thumb.closest('[data-gallery]');
      var main = gallery && gallery.querySelector('[data-gallery-main] img');
      var src = thumb.getAttribute('data-gallery-thumb');
      if (main && src) {
        main.src = src;
        var srcset = thumb.getAttribute('data-gallery-srcset');
        if (srcset) main.srcset = srcset;
        var alt = thumb.getAttribute('data-gallery-alt');
        if (alt !== null) main.alt = alt;
        gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
          t.setAttribute('aria-current', t === thumb ? 'true' : 'false');
        });
      }
    }
  });

  /* ---- Escape closes dropdowns and the mobile panel ---- */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('details[data-dropdown][open]').forEach(function (d) {
      d.removeAttribute('open');
    });
    var toggle = document.querySelector('[data-nav-toggle][aria-expanded="true"]');
    if (toggle) toggle.click();
  });
})();
